import * as React from 'react';
import { shallowEqual } from 'react-redux';

import { Stack, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';
import useAsyncGetNewMessages from '../../../../hooks/useAsyncGetNewMessages';
import { InboxItemsResponse } from '../../../../sic-lib/api/newRecent/types/InboxItemsResponse';
import { RequestStatus } from '../../../../sic-lib/enums/RequestStatus';
import { ChannelsStats } from '../../../../sic-lib/types/ChannelsStats';
import { useAppSelector } from '../../../../store/hooks';
import PageStatus from '../../../Navigation/PageStatus/PageStatus';
import ChannelDetails from '../ChannelDetails/ChannelDetails';

const useStyles = makeStyles()((theme: Theme) => ({
    flexWrapper: {
        height: '100%',
        overflow: 'auto',
        [theme.breakpoints.up(0)]: {
            padding: theme.spacing(1),
        },
        [theme.breakpoints.up('sm')]: {
            padding: theme.spacing(1, 2),
        },
    },
    flexItem: {
        margin: theme.spacing(0, 0),
    },
}));

interface Props {
    channelStats: ChannelsStats[];
}

export default function UnrespondedByChannelList({ channelStats }: Props) {
    const { classes } = useStyles();

    const store = useAppSelector(state => {
        return {
            clientId: state.user?.clientId || -1,
            userName: state.user?.userName || '',
        };
    }, shallowEqual);

    const [newMessages, setNewMessages] = React.useState<InboxItemsResponse>();
    const { requestStatus, asyncGetNewMessages } = useAsyncGetNewMessages();

    React.useEffect(() => {
        async function request() {
            const asyncResult = await asyncGetNewMessages(store.clientId, store.userName);

            if (asyncResult) {
                setNewMessages(asyncResult);
            }
        }

        request();
    }, []);

    return (
        <PageStatus
            showError={requestStatus === RequestStatus.error}
            showLoading={requestStatus !== RequestStatus.success}
        >
            <Stack direction="column">
                {channelStats.length < 1 && (
                    <Typography component="h5" color="info" m={2}>
                        All caught up!
                    </Typography>
                )}
                {channelStats &&
                    channelStats.map(channel => (
                        <ChannelDetails config={channel} key={channel.type} />
                    ))}
                {/*newMessages !== undefined &&
                    newMessages.items.reverse().map(itm => (
                        <Grid item xs='auto' key={itm.contactId} className={classes.flexItem}>
                            <NewMessageListItem
                                config={itm}
                            />
                        </Grid>
                    ))
                */}
            </Stack>
        </PageStatus>
    );
}
